'use client';

import Image from 'next/image';
import { useState } from 'react';

type GalleryItem = {
  src: string;
  title: string;
};

type Props = {
  id: string;
  paginate: string;
  offset: string;
  itemsperrow: string;
  islinkedthumbnailsgallery: string;
  showtitles: string;
  itemsperpage: string;
  outeroffset: string;
  uselightbox: string;
  usefoldertorenderimages: string;
  foldernametorenderimages: string;
  scaleupcaptionyyjssor: string;
  addtitleonsyncfolder: string;
  elementsToRender: GalleryItem[];
};

export function Masonrygallery(props: Props) {
  const [isImageLoaded, setImageLoaded] = useState<boolean>(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const columns = Number.parseInt(props.itemsperrow);
  const galleryClass = `${props.id}_masonry-gallery`;
  const columnCountCSS = `
.${galleryClass} { column-count: ${columns}; }
@media (max-width: 980px) { .${galleryClass} { column-count: ${Math.max(columns - 1, 1)}; } }
@media (max-width: 700px) { .${galleryClass} { column-count: ${Math.max(columns - 2, 1)}; } }
@media (max-width: 500px) { .${galleryClass} { column-count: 1; } }
`;

  return (
    <div className="ui-relative ">
      {!isImageLoaded && (
        <div className="loading_div">
          <div
            className="ui-border-none waiting_gif ui-bg-center ui-bg-no-repeat"
            style={{ background: 'url("/msgloading.gif")' }}
          />
        </div>
      )}

      <style>{columnCountCSS}</style>
      <div className={`${galleryClass} wookmark-initialised`}>
        {props.elementsToRender.map((item) => (
          <div
            key={item.src}
            title={item['title']}
            className={`${props.id}_grid_item !ui-shadow-none ui-break-inside-avoid`}
          >
            <Image
              onLoad={handleImageLoad}
              src={item['src']}
              alt={item['title']}
              title={item['title']}
              className="!ui-w-[98%] !ui-relative"
              fill={true}
            />
            {(props.showtitles === 'show_titles' ||
              props.showtitles === 'true') && (
              <div className="ui-mt-1 ui-ml-1">{item['title']}</div>
            )}
          </div>
        ))}
      </div>

      <div className="clear_div ui-clear-both ui-h-0 ">&nbsp;</div>
    </div>
  );
}

export default Masonrygallery;
